import type { WpPost } from "@/server/wp.server";

const TITLE_LIMIT = 60;
const DESC_LIMIT = 155;

export const BLOG_TITLE_SUFFIX = " | Perceptica";

export function stripHtml(html: string) {
  return html.replace(/<[^>]*>/g, "").replace(/\s+/g, " ").trim();
}

function truncateWords(text: string, limit: number) {
  if (text.length <= limit) return text;
  const cut = text.slice(0, limit);
  const lastSpace = cut.lastIndexOf(" ");
  return `${(lastSpace > limit * 0.6 ? cut.slice(0, lastSpace) : cut).replace(/[\s,;:.-]+$/, "")}…`;
}

/** Post title with the short brand suffix, kept under Google's ~60 char cut. */
export function blogMetaTitle(post: WpPost, fallbackTitle?: string, useOverrides = true) {
  const custom = useOverrides ? post.seo?.metaTitle?.trim() : "";
  if (custom?.endsWith(BLOG_TITLE_SUFFIX)) return custom;
  const base = custom || fallbackTitle || stripHtml(post.title.rendered);
  const withSuffix = `${base}${BLOG_TITLE_SUFFIX}`;
  if (withSuffix.length <= TITLE_LIMIT) return withSuffix;
  if (base.length <= TITLE_LIMIT) return base;
  return truncateWords(base, TITLE_LIMIT);
}

/** Hand-written description when available, otherwise a clean 155-char excerpt. */
export function blogMetaDescription(post: WpPost, useOverrides = true) {
  const custom = useOverrides ? post.seo?.metaDescription?.trim() : undefined;
  if (custom) return custom;
  return truncateWords(stripHtml(post.excerpt.rendered), DESC_LIMIT);
}

/** Slug that should own the canonical URL for this article. */
export function canonicalSlugFor(post: WpPost) {
  return post.seo?.canonicalSlug?.trim() || post.slug;
}
